import DigitalAssetsRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/digital-assets/DigitalAssetsRoot/DigitalAssetsRootWithErrorBoundary";
import { translate } from "app/filters/i18nFilter";
import {
    COMPANY_ANALYSIS_COMPETITORS,
    COMPANY_ANALYSIS_DIGITAL_ASSETS,
    COMPANY_ANALYSIS_SIGNALS,
    COMPANY_ANALYSIS_TECHNOLOGIES,
    COMPANY_ANALYSIS_KEY,
    COMPANY_ANALYSIS_OVERVIEW,
    COMPANY_ANALYSIS_CONTACTS,
    HOME_PAGE_ROUTE,
    COMPANY_ANALYSIS_ROOT,
    ACCOUNT_OVERVIEW_COMPANY,
    ACCOUNT_OVERVIEW_CONTACTS,
} from "app/pages/sales-intelligence/constants/routes";
import CompanyRootPage from "app/pages/sales-intelligence/pages/company-analysis/containers/CompanyRootPage/CompanyRootPage";
import { CompetitorsSectionRoot } from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/CompetitorsSectionRoot/CompetitorsSectionRoot";
import ContactsSectionRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/contacts/ContactsSectionRoot/ContactsSectionRoot";
import OverviewSectionRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/OverviewSectionRoot/OverviewSectionRoot";
import SignalsSectionRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/signals/SignalsSectionRoot/SignalsSectionRoot";
import TechnologiesCompanySectionRoot from "app/pages/sales-intelligence/pages/company-analysis/containers/technologies/TechnologiesSectionRoot/TechnologiesCompanySectionRoot";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

const getSharedCompanyConfig = (subSection: string) => ({
    reset: undefined,
    parent: COMPANY_ANALYSIS_KEY,
    homeState: HOME_PAGE_ROUTE,
    pageId: {
        section: "account-overview",
        subSection,
        subSubSection: undefined,
    },
    trackingId: {
        section: "Account Review",
        subSection: "company",
        subSubSection: "company overview",
    },
    stateNameForEductionBar: ACCOUNT_OVERVIEW_COMPANY,
});

export const COMPANY_STATE_CONFIG: Record<string, IRouterState> = {
    [COMPANY_ANALYSIS_KEY]: {
        abstract: true,
        parent: COMPANY_ANALYSIS_ROOT,
        url: "/:key",
        component: CompanyRootPage,
    },
    [COMPANY_ANALYSIS_OVERVIEW]: {
        stateId: COMPANY_ANALYSIS_OVERVIEW,
        url: `/company?activeCard`,
        get pageTitle() {
            return translate("si.company-analysis.company.document.title");
        },
        component: OverviewSectionRoot,
        ...getSharedCompanyConfig("company"),
    },
    [COMPANY_ANALYSIS_SIGNALS]: {
        stateId: COMPANY_ANALYSIS_SIGNALS,
        url: `/signals?activeSignalFilter&isShowManageSignals`,
        params: {
            activeSignalFilter: { dynamic: true },
            isShowManageSignals: { dynamic: true },
        },
        get pageTitle() {
            return translate("si.company-analysis.signals.document.title");
        },
        component: SignalsSectionRoot,
        ...getSharedCompanyConfig("signals"),
    },
    [COMPANY_ANALYSIS_DIGITAL_ASSETS]: {
        stateId: COMPANY_ANALYSIS_DIGITAL_ASSETS,
        url: `/digital-assets`,
        get pageTitle() {
            return translate("si.company-analysis.digital-assets.document.title");
        },
        component: DigitalAssetsRoot,
        ...getSharedCompanyConfig("digital-assets"),
    },
    [COMPANY_ANALYSIS_TECHNOLOGIES]: {
        stateId: COMPANY_ANALYSIS_TECHNOLOGIES,
        url: `/technologies`,
        get pageTitle() {
            return translate("si.company-analysis.technologies.document.title");
        },
        component: TechnologiesCompanySectionRoot,
        ...getSharedCompanyConfig("technologies"),
    },
    [COMPANY_ANALYSIS_COMPETITORS]: {
        stateId: COMPANY_ANALYSIS_COMPETITORS,
        url: `/competitors`,
        get pageTitle() {
            return translate("si.company-analysis.competitors.document.title");
        },
        component: CompetitorsSectionRoot,
        ...getSharedCompanyConfig("competitors"),
    },
    [COMPANY_ANALYSIS_CONTACTS]: {
        stateId: COMPANY_ANALYSIS_CONTACTS,
        url: `/contacts`,
        get pageTitle() {
            return translate("si.company-analysis.contacts.document.title");
        },
        component: ContactsSectionRoot,
        ...getSharedCompanyConfig("contacts"),
    },
};
